import { Injectable } from '@angular/core';
import { ShelfTalkerCardContentViewModel } from '../../shared/shelf-talker-card-content-view-model';
import type { Observable } from 'rxjs';
import type { DougShelfTalkerCardData } from '../../../../../../../models/shelf-talkers/doug-shelf-talker-card-data';

@Injectable()
export class Doug5By7ShelfTalkerContentViewModel extends ShelfTalkerCardContentViewModel {
  public readonly data$: Observable<DougShelfTalkerCardData | null>;
}
